import { Typography } from "@mui/material";
import { allHeadlineTags, TagToComponentMap } from "nwon-html-to-react";

/**
 * All headlines mapped to their Typography counterpart, hyphenated or not.
 */
export const mappedHeadlines = (): TagToComponentMap => {
  return Object.fromEntries(
    allHeadlineTags.map((tag) => [
      tag,
      (props) => (
        <Typography
          sx={{ color: (theme) => theme.palette.common.black }}
          variant={tag}
          {...props.attributes}
          className={`${props.attributes.className ?? ""} marginTop`}
        >
          {props.children}
        </Typography>
      ),
    ]),
  );
};
